import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import { useTranslations } from "../../../contexts/translationContext";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface Props extends PopupProps {
    projectTypeId: number
}

interface ProjectTypeUserDefinedField {
    projectTypeId: number
    userDefinedFieldId: number
}

const AddProjectTypeUserDefinedFieldPopup: React.FC<Props> = ({ show, onHide, projectTypeId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();

    const userDefinedFields = useSelectListOptions('api/v1/selectlist/UserDefinedFields', '-- Select user-defined field');

    const [formData, setFormData] = useState<ProjectTypeUserDefinedField | undefined>({ projectTypeId: projectTypeId } as ProjectTypeUserDefinedField);

    function submit() {
        if (formData) {
            DataService
                .create<number>(`api/v1/ProjectTypeUserDefinedFields/`, formData)
                .then(response => {
                    handleResult(response)
                    setServerErrors(response)
                    if (response.isSuccesful === true && onHide)
                        onHide()

                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'userDefinedFieldId', label: 'User-defined field', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add user-defined field'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('userDefinedFieldId')} options={userDefinedFields} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddProjectTypeUserDefinedFieldPopup;